declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
  }
}

function track(eventName: string, params: Record<string, string>) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({ event: eventName, ...params })
  }
}

export function trackWidgetView(league: string) {
  track('odds_widget_view', { odds_league: league })
}

export function trackOddsClick(league: string, sportsbook: string, selectionName: string, marketName: string, eventName: string) {
  track('odds_widget_odds_click', { odds_league: league, odds_sportsbook: sportsbook, odds_selection_name: selectionName, odds_market_name: marketName, odds_event_name: eventName })
}

export function trackPlaceBet(league: string, sportsbook: string, selectionName: string) {
  track('odds_widget_place_bet', { odds_league: league, odds_sportsbook: sportsbook, odds_selection_name: selectionName })
}

export function trackMarketChange(league: string, marketName: string, eventName: string) {
  track('odds_widget_market_change', { odds_league: league, odds_market_name: marketName, odds_event_name: eventName })
}
